import React, { memo } from 'react';
import { UNSAFE_Box as Box, UNSAFE_Text as Text } from '@atlaskit/ds-explorations';
import { useGlobalTheme } from '@atlaskit/theme/components';
import { backgroundColors, textColors } from './internal/theme';
import { formatValue } from './internal/utils';

/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */
var Badge = /*#__PURE__*/memo(function Badge(_ref) {
  var _style$backgroundColo, _style$color;

  var _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? 0 : _ref$children,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 99 : _ref$max,
      style = _ref.style,
      testId = _ref.testId;

  var _useGlobalTheme = useGlobalTheme(),
      mode = _useGlobalTheme.mode;

  var backgroundColor = (_style$backgroundColo = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _style$backgroundColo !== void 0 ? _style$backgroundColo : backgroundColors[appearance][mode];
  var textColor = (_style$color = style === null || style === void 0 ? void 0 : style.color) !== null && _style$color !== void 0 ? _style$color : textColors[appearance][mode];
  return /*#__PURE__*/React.createElement(Box, {
    testId: testId,
    as: "span",
    borderRadius: "badge",
    display: "inlineFlex",
    paddingInline: "sp-75",
    paddingBlock: "sp-25",
    UNSAFE_style: {
      backgroundColor: backgroundColor,
      color: textColor
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "12px",
    lineHeight: "12px",
    textAlign: "center"
  }, typeof children === 'number' && max ? formatValue(children, max) : children));
});
Badge.displayName = 'Badge';
export default Badge;